export const codeMask = {
    prefix: '',
    thousands: '',
    decimal: '',
    precision: '',
    align: 'left'
}
 